<template>
  <div class="custom-v-mainsss">
    <v-navigation-drawer
      :value="drawer"
      :fixed="mobile"
      :temporary="mobile"
      :mobile-breakpoint="0"
      app
      clipped
      :width="widthDrawer"
      @input="$emit('change-drawer', $event)"
    >
      <slot name="navigation-drawer" />
    </v-navigation-drawer>

    <div
      class="  custom-v-main"
      :style="cssVars"
      :class="{
        'custom-side-panel': drawer && !mobile,
      }"
    >
      <div class="pa-1 pl-4">
        <slot name="main" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseLayout',
  props: {
    mobile: Boolean,
    drawer: Boolean,
    widthDrawer: {
      type: Number,
      default: 400,
    },
    paddingTop: {
      type: Number,
      default: 88,
    },
  },
  computed: {
    cssVars() {
      return {
        '--width-drawer': this.widthDrawer + 'px',
        '--padding-top': this.paddingTop + 'px',
      };
    },
  },
};
</script>

<style scoped>
.custom-v-main {
  padding-top: var(--padding-top);
  margin: 0 0 0 auto;
  background-color: #f5f5f5;
}
.custom-side-panel {
  width: calc(100% - var(--width-drawer));
}
</style>
